import React from "react";

export default function Skeleton({ label = "Loading" }) {
  return (
    <div className="rr-stack" role="status" aria-label={label}>
      <div className="rr-skeleton" />
      <div className="rr-skeleton" />
      <div className="rr-skeleton" />
    </div>
  );
}
